export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_10.759768db.jpg";